import { createQuery, request } from '@luna/api';
import { getBankMessagesUrl } from '@shared/bank-messages-utils';
import type { BankMessage } from '@shared/bank-messages-utils';

import { areMustReadMessagesEnabled } from './MustReadMessagesService';

type Response = { messages: BankMessage[] };

export const [useMandatoryMessages, { queryApiIfNeeded: queryMandatoryMessagesIfNeeded }] =
    createQuery({
        name: 'must-read-messages/mandatory-messages',
        condition: () => areMustReadMessagesEnabled(),
        payloadCreator: async () => {
            const URL = `${getBankMessagesUrl()}?filterByFlags=mandatory,unread`;
            const response = await request<Response>(URL);

            return response.messages ?? [];
        },
    });
